<div class="dashboard-heading">
  <h1>{{ 'MESSAGE' | translate }}</h1>

  <div>
    <dx-button text="{{ 'CREATE' | translate }}" (onClick)="createProblem()" class="btn" icon="mdi mdi-folder-plus"></dx-button>
  </div>
</div>

<div class="containe">
  <dx-accordion
    [dataSource]="problems$ | async"
    [collapsible]="true"
    [multiple]="true"
    [selectedIndex]="null"
    [animationDuration]="300"
    class="accordion-new">
    <div *dxTemplate="let problem of 'title'">
      <div class="accordion-row accordion-row-problems justify-content-between align-items-center">
        <div class="mb-xl-0 mb-2">
          <div class="font-size-15-em color-grey-label line-height-1-2">
            {{ 'CODE' | translate }}
          </div>
          <div>{{ problem.id }}</div>
        </div>

        @if (problem.isActive) {
          <div class="mb-xl-0 mb-2">
            <div class="font-size-15-em color-grey-label line-height-1-2">
              {{ 'ACTIVE' | translate }}
            </div>
            <span class="mdi mdi-check outline color-green-dark font-size-26-em"></span>
          </div>
        }

        @if (!problem.isActive) {
          <div class="mb-xl-0 mb-2">
            <div class="font-size-15-em color-grey-label line-height-1-2">
              {{ 'DECIDED' | translate }}
            </div>
            <span class="mdi mdi-close outline color-green-dark font-size-26-em"></span>
          </div>
        }

        <div class="mb-xl-0 mb-2">
          <div class="font-size-15-em color-grey-label">{{ 'DATE_PUBLICATION' | translate }}</div>
          <div class="d-flex align-items-center">
            <span class="me-2 font-size-16 color-green-dark letter-spacing-1 font-weight-middle">
              {{ problem.publishDate | date: 'HH:mm dd-MM-yyyy' }}
            </span>
            <span class="mdi mdi-calendar-month color-green-dark font-size-26"></span>
          </div>
        </div>

        <div class="mb-xl-0 mb-2 font-size-18-em font-weight-middle line-height-1-7">
          {{ problem.title }}
        </div>

        <div class="mb-xl-0 mb-2">
          <div class="font-size-15-em color-grey-label">{{ 'TIME_ELIMINATION' | translate }}</div>
          <div class="d-flex align-items-center">
            <span class="me-2 font-size-16 color-green-dark letter-spacing-1 font-weight-middle">
              {{ getTimeLeft(problem) }}
            </span>
            @if (getTimeLeft(problem)?.length > 0) {
              <span class="mdi mdi-clock-time-nine-outline color-green-dark font-size-26-em"></span>
            }
          </div>
        </div>

        <div class="mb-xl-0">
          <dx-button
            text="{{ 'EDIT' | translate }}"
            (onClick)="editProblem($event, problem.id)"
            class="btn mb-2"
            icon="mdi mdi-pencil"></dx-button>
          <dx-button
            text="{{ 'DELETE' | translate }}"
            (onClick)="deleteProblem($event, problem.id)"
            class="btn btn-light mb-2 ms-2"></dx-button>
        </div>
      </div>
    </div>
    <div *dxTemplate="let problem of 'item'">
      <div class="dx-item-content-block">
        <div>
          @if (problem.image) {
            <img [src]="convertImage(problem)" />
          }
        </div>
        <div>{{ problem.description }}</div>
      </div>
    </div>
  </dx-accordion>
</div>
